import React from 'react';
import hero from './../../images/hero-lady.jpg';
import { Typography, Grid, Box } from '@mui/material';
import { PrimaryButton } from '../Button';

const Hero = () => {
  return (
    <Grid container spacing={2} sx={{ mx: 2 }} alignItems={'center'} py={4}>
      <Grid size={6} display='flex' alignItems={'center'} flexDirection='column'>
        <Box>
          <Typography variant="h2" component="h1" align='left' data-testid="hero-text" sx={{ mb: 2 }} fontSize={{ xs: '3rem', lg: '4rem', xl: '6rem'}}>
            From the washing line<br />
            to the fashion line
          </Typography>
        
          <a href="/products">
            <PrimaryButton>SHOP NOW</PrimaryButton>
          </a>
        </Box>
      </Grid>
      <Grid size={6} display={'flex'} justifyContent={'center'}>
        <img src={hero} alt='hero' style={{ width: '80%', height: 'auto', borderRadius: '10%' }} data-testid="hero-image" />
      </Grid>
      
    </Grid>
  );
};

export default Hero;